import { ArrowRight } from "lucide-react";
import { CHECKOUT_URL, MEDIA } from "@/lib/constants";

export default function FinalCTA() {
    return (
        <section
            id="final-cta"
            data-testid="section-final-cta"
            className="relative bg-emerald-brand text-white overflow-hidden"
        >
            <div
                className="absolute inset-0 opacity-[0.08] pointer-events-none"
                style={{
                    backgroundImage: `url(${MEDIA.backgroundTexture})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            />
            <div className="absolute inset-0 grain pointer-events-none opacity-30" />
            <div className="relative max-w-4xl mx-auto px-5 sm:px-8 lg:px-12 py-24 lg:py-32 text-center">
                <div className="reveal">
                    <div className="flex items-center justify-center gap-3 mb-6">
                        <span className="h-px w-10 bg-gold-brand" />
                        <span className="label-eyebrow">Última chamada</span>
                        <span className="h-px w-10 bg-gold-brand" />
                    </div>
                    <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
                        Daqui a 30 dias, você pode estar
                        <br />
                        falando inglês —
                        <br />
                        ou ainda{" "}
                        <span className="italic text-gold-brand">
                            esperando o momento certo
                        </span>
                        .
                    </h2>
                    <p className="mt-8 text-lg sm:text-xl text-white/85 leading-relaxed max-w-2xl mx-auto">
                        O método existe. A garantia existe. O preço é o de um
                        almoço. A única coisa que falta é você decidir destravar.
                    </p>
                    <a
                        href={CHECKOUT_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="cta-final"
                        className="btn-gold pulse-gold mt-10 text-base sm:text-lg"
                    >
                        Quero começar agora por R$ 47
                        <ArrowRight className="w-5 h-5" />
                    </a>
                    <p className="mt-6 text-sm text-white/60">
                        Acesso imediato · Pagamento seguro · 7 dias de garantia
                    </p>
                </div>
            </div>
        </section>
    );
}
